<template>
  <v-row no-gutters class="pt-2 pb-2">
    <v-col cols="12">
    <div class="blue lighten-5 rounded ">
      <v-row no-gutters class="ma-0 pa-0 align-center">
        <v-col cols="6">
          <span class="text-h7 font-weight-bold ml-2">{{kupac}}</span>
        </v-col>
        <v-col cols="6" class="d-flex align-center justify-end pr-3">
          <span v-if="storno" class="text-h6 font-weight-bold red--text mr-3">{{ t.storno }}</span>
          <span class="text-h6">{{kolicina}} m3</span>
        </v-col>
      </v-row>
      <v-row no-gutters class="">
        <v-col cols="12" class="">
          <span class="ml-2">Otpr.{{brojotpremnice}}, {{receptura}}, {{gradiliste}}, {{vozac}}, {{localDate(datum)}}, {{vrijeme}}</span>
        </v-col>
      </v-row>
    </div>
    </v-col>
  </v-row>
</template>

<script>
import dateFormat from '@/snippets/dateFormat'
import { betonT } from '@/snippets/betonLang'

export default {
  name: 'betoncard',
  props: ['kupac', 'kolicina', 'gradiliste', 'vozac', 'receptura','datum', 'vrijeme', 'brojotpremnice', 'storno'],
  data () {
    return {
      msg: '',
      lang: {},
      langC: {},
      locMonths: [],
      locYears: [],
      saving: false,
      postNew: false,
      query: {}
    }
  },
  mounted () {

  },
  methods: {
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
      }

  },
  computed: {
    t () {
      return betonT(this.$store.state.language)
    }
  },
  watch: {

  },
  components: {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
